import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatSnackBar} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {MapComponent } from '../map.component'
import {FourDService, Client, JobType, TransformType,Transform, Dataset, Folder, ProcessorAPI, Job, JobBatch} from '4d-mapper'
import {TranslateService} from '@ngx-translate/core';
import {BaseComponent} from '../../../commons/BaseComponent';
import {MapService} from '../../../commons/map.service';
import {forkJoin} from 'rxjs';
import {AppService} from '../../../commons/app.service';
import {Location} from '@angular/common';
import { QMAP } from 'ng-qmap';
import { MapDataService } from '../../../v2/commons/map-data.service'
const Cesium = (<any>window).Cesium

@Component({
  selector: 'process-comp',
  templateUrl: './processing.component.html',
  styles: ['div:nth-child(2) { background: rgba(0, 0, 0, 0.04);}']

})
export class ProcessingDetailsComponent extends BaseComponent implements OnInit, OnDestroy {
  
  jobType:JobType
  job:Job
  transformType:TransformType
  api:ProcessorAPI
  qMap:QMAP[]
  batches:JobBatch[] = []

  arguments:any = {}
  files:Dataset[] = []

  constructor(private route: ActivatedRoute, public router: Router,
              snackBar: MatSnackBar, dialog: MatDialog, private location: Location,
              public mapComp: MapComponent, public mapService: MapService,
              private trans: TranslateService, 
              public fourD: FourDService, public service: AppService, private dataService:MapDataService) {
    super(router, snackBar, dialog);
    
    mapComp.setTab('processing')
    
    this.dataService.onSceneReady().subscribe(s => {
      route.params.subscribe(params => {

        let incomingId = parseInt(params.id);

        if(params.type == 'job'){
          
          this.jobType = this.fourD.jobTypes.find(j => j.id == incomingId );
          if ( incomingId == 99999999 ) {

          } else if ( !this.jobType ) {
            console.log ( '!!!', params );
            return;
          }

          if(this.jobType.baseTransform) {
            this. qMap = this.jobType.baseTransform.qMap;
          }

          if(params.jid == 'new'){
            this.job = new Job(this.fourD.V)
            this.job.jobType = this.jobType
            this.job.account = this.fourD.activeTeam
            this.job.name = "New " + this.jobType.name
            this.job.scene = this.dataService.scene.value
            this.dataService.sceneJobs.add(this.job)
            this.job.saveObservable().subscribe()
          }

          else{
            var existing = this.dataService.sceneJobs.values.find(v => params.jid == '' + v.id)
            if(existing){
              this.job = existing
              this.refreshFiles()
              existing.batches().queryObservable().subscribe(r => 
                this.batches = r.items
              )
            }
            else{
              this.openDialog('MAP.PHOTOGRAM.JOB_LOCATON','MAP.PHOTOGRAM.JOB_ID ' + params.jid + ' MAP.PHOTOGRAM.NOT_FOUND')
            }
          
          }
        }
        else {
          this.transformType = this.fourD.transformTypes.find(j => j.id == parseInt(params.id))
          this.qMap = this.transformType['qMap']

          this.transformType.apis.queryObservable().subscribe(res => {
              if(res.items.length){
                this.api = res.items[0]
                this.qMap = this.api['qMap']
              }
          })
        }

        console.log ( '@@@@@ job', params, this.job );

        mapComp.detailsNav.open()
      })
    })
      

  }

  destroy(){
    if(this.job && !this.job.id){
      this.dataService.sceneJobs.remove(this.job)
    }
  }

  refreshFiles(){
    this.job.inputDatasets.queryObservable().subscribe(s => {
      this.arguments = {}
      this.files = s.items
      var initParams = s.items.find(element => 
        !!element.initParams && !!Object.keys(element.initParams).length
      );

      if(initParams){
        var qMap = this.qMap
        this.arguments = initParams.initParams
        this.qMap = null
        // bit hacky for qMap to redraw
        setTimeout(() => this.qMap = qMap,100)
      }
    
    })
  }
  pickFiles(){
    this.openDialogWithModeAndFilterAndMeta({
      project: this.mapService.currentProject
    }, 'file_all', 'Dataset', 'PROJECT.DIALOG.ADD_TRANSFORM_TITLE', 'PROJECT.DIALOG.ADD_TRANSFORM_TEXT',).subscribe(dest => {

      if(this.jobType){
        
      
        
        var addFiles = () => {
          var obs = null
          if (dest instanceof Folder) {
            obs = this.job.inputFolders.addObserveable(dest)
          }
          else if (dest && Array.isArray(dest)) {
            obs = forkJoin(dest.map(d => 
              this.job.inputDatasets.addObserveable(d)
            ))
          }

          if(obs)
            obs.subscribe(_ => {
              this.refreshFiles()
              this.openSnackBarSuccess('GENERIC.OK')
            },
              e => this.openSnackBarError(e.message)
            )
          else
            this.openSnackBarError('PROCESSING.NO_FILES')
        }


        if(!this.job.id){
          this.job.saveObservable().subscribe(s => {
            addFiles()
          })
        }
        else{
          addFiles()
        }
      }
      else
        if (dest instanceof Folder) {
         // TODO
        }
        else if (dest && Array.isArray(dest)) {
          this.files = dest
        }
      },
      e => this.openSnackBarError(e.message, null)
    )
  }
  start(){
    if(this.jobType){
      this.job.startTransform(this.jobType.baseTransform, this.arguments).subscribe(s => {
        this.openDialog('GENERIC.SUCCESS' + this.jobType.name + ' MAP.PHOTOGRAM.JOB_STARTED2').subscribe(s => {
          this.router.navigate(['../..','processing'],{relativeTo:this.route})
        })
      },
        e => this.openSnackBarError('GENERIC.ERROR ' + e.message)
      )
    }
      
    else
      this.startAdHoc(this.files[0],this.transformType)
  }

  startAdHoc(d: Dataset, tt: TransformType,api?:ProcessorAPI) {

  // when its an api specific tak that to end otherwise default
      //var extraURL = params.api ? ('/' + params.api.id) : ''
      
      this.arguments.for_transform_group = this.mapService.scene.id

      d.applyTransform(tt, this.arguments).subscribe(s => {
          this.openDialog('GENERIC.SUCCESS' + this.transformType.name + ' MAP.PHOTOGRAM.TASK_STARTED').subscribe(s => {
            this.router.navigate(['../..','processing'],{relativeTo:this.route})
          })
        },
        e => this.openSnackBarError('GENERIC.ERROR ' + e.message)
      )

  }
  nuke(){
    this.openConfirmDelete(() => {
      this.job.destroyObservable().subscribe(s => {
        this.dataService.sceneJobs.remove(this.job)
        this.openDialog('GENERIC.SUCCESS'+ this.jobType.name + ' MAP.PHOTOGRAM.JOB_DELETED').subscribe(s => {
          this.router.navigate(['../..','processing'],{relativeTo:this.route})
        })
      },
      e => this.openSnackBarError('GENERIC.ERROR ' + e.message)
    )
      
    }, this.job.name)
  }

  rmFile(d:Dataset){

    if(this.job){
      this.openConfirmDelete(() => 
      this.job.inputDatasets.removeObservable(d).subscribe(s => {
        this.files = this.files.filter(f => f != d)

      }, e => this.openSnackBarError(e.message))
      ,d.name)
    }
  }
}
